import { Endpoint } from '../../../../constants/endpoints';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import { FetchAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import MedicationService from '../../services/medication-service';
import BaseController from '../../../../controllers/BaseController';

export default class RevertLastEvent {

  static handleMountLayout(baseController: BaseController): void {
    const { encounterId, patientId } = baseController.historyService.getCurrentRouteParams();
    baseController.context.set({ encounterId, patientId });
    InformationBarUtils.collapsedBar = true;
  }

  static fetchReasonMount(event: MountEvent, baseController: BaseController): void {
    const { itemType } = baseController.historyService.getCurrentRouteParams();
    const fetchReason = event.target as FetchAPI;
    const establishmentCode = foundationContext.getEstablishment()?.id;
    fetchReason.setParameters({ establishmentCode, status: String(itemType) }, { skip: true });
  }

  static callEndPoint(formApi: FormAPI, body: Record<string, Value>, baseController: BaseController): void {
    HttpService.post(Endpoint.REVERSE_LAST_EVENT, {}, { body })
      .then(() => {
        MedicationService.showToast(MessageService.translate('text.revert-event'), ToastLevel.SUCCESS)
        this.goToTimeline(baseController)
      })
      .catch((error) => {
        const message = error.body.messageDescription;
        const errorMessage = error.body.errors.join('; ')
        MedicationService.showToast(message ?? errorMessage, ToastLevel.ERROR)
      }).finally(() => {
        formApi.setLocked(true);
      });
  }

  private static goToTimeline(baseController: BaseController): void {
    const { encounterId, patientId } = baseController.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION, {
      encounterId,
      patientId,
    });
    applicationContext.clearNavigationStack();
  }
}